import React, { useState, useEffect } from "react";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function MultipleSelectPlaceholder({
  products,
  selectedProducts,
  onChange,
  onScroll,
  existingSubscribeProduct,
}) {
  const [expanded, setExpanded] = useState(null);
  const [selectOpen, setSelectOpen] = useState(false);
  const [manuallyUnselected, setManuallyUnselected] = useState(false);

  // Ensure existing products are selected once unless manually unselected
  useEffect(() => {
    if (existingSubscribeProduct && !manuallyUnselected) {
      const isAlreadySelected = selectedProducts.some(
        (item) => item.id === Number(existingSubscribeProduct.woocommerce_product_id)
      );
      console.log("Checking existing subscription:", isAlreadySelected);

      if (!isAlreadySelected) {
        console.log("Adding existing subscription to selection");
        onChange([
          ...selectedProducts,
          {
            id: Number(existingSubscribeProduct.woocommerce_product_id),
            name: existingSubscribeProduct.event_name,
          },
        ]);
      }
    }
  }, [existingSubscribeProduct, selectedProducts, onChange, manuallyUnselected]);

  // Handle product selection
  const handleChange = (id, name) => {
    const isExistingSubscribedProduct =
      Number(existingSubscribeProduct?.woocommerce_product_id) === Number(id);

    console.log("Handling selection change for ID:", id, "Name:", name);

    let updatedSelection = selectedProducts.some((item) => item.id === id)
      ? selectedProducts.filter((item) => item.id !== id)
      : [...selectedProducts, { id, name }];

    // If existing subscribed product is unselected, ensure it is removed and prevent re-selection
    if (isExistingSubscribedProduct) {
      console.log("Removing existing subscribed product from selection");
      updatedSelection = updatedSelection.filter(
        (item) => Number(item.id) !== Number(existingSubscribeProduct.woocommerce_product_id)
      );
      setManuallyUnselected(true);
    }

    console.log("Updated Selection:", updatedSelection);
    onChange(updatedSelection);
  };

  // Toggle Accordion expansion
  const handleExpand = (id) => {
    console.log("Toggling expansion for ID:", id);
    setExpanded(expanded === id ? null : id);
  };

  // Check if product or variant is selected
  const isChecked = (id) => {
    console.log("selectedProducts:", selectedProducts);
    const checked = selectedProducts.some((item) => item.id === id) ||
      (Number(existingSubscribeProduct?.woocommerce_product_id) === Number(id) && !manuallyUnselected);
    console.log("Checked status for ID:", id, "Status:", checked, existingSubscribeProduct?.woocommerce_product_id);
    return checked;
  };

  return (
    <FormControl fullWidth>
      <InputLabel>Products</InputLabel>
      <Select
        multiple
        value={selectedProducts.map((item) => item.id)}
        open={selectOpen}
        onOpen={() => setSelectOpen(true)}
        onClose={() => setSelectOpen(false)}
        renderValue={(selected) =>
          selectedProducts.map((item) => item.name).join(", ")
        }
        MenuProps={{
          PaperProps: {
            onScroll: onScroll,
            style: { maxHeight: 300, overflowY: "auto" },
          },
        }}
      >
        {products.map((product) => (
          <MenuItem key={product.woocommerce_product_id_int}>
            <Accordion
              expanded={expanded === product.woocommerce_product_id_int}
              onChange={() => handleExpand(product.woocommerce_product_id_int)}
              sx={{ boxShadow: "none", background: "transparent" }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Checkbox
                  checked={isChecked(product.woocommerce_product_id_int)}
                  onChange={() =>
                    handleChange(
                      product.woocommerce_product_id_int,
                      product.event_name
                    )
                  }
                />
                <ListItemText primary={product.event_name} />
              </AccordionSummary>

              {/* Show Product Variants if Available */}
              {product.product_variants && (
                <AccordionDetails>
                  {product.product_variants.map((variation) => (
                    <MenuItem
                      key={variation.product_variant_id}
                      onClick={() =>
                        handleChange(
                          variation.product_variant_id,
                          `${product.event_name} - ${variation.name}`
                        )
                      }
                    >
                      <Checkbox checked={isChecked(variation.product_variant_id)} />
                      <ListItemText primary={variation.name} />
                    </MenuItem>
                  ))}
                </AccordionDetails>
              )}
            </Accordion>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
